//import sound0 from '../assets/mp3/0.mp3';
// import sound1 from '../assets/mp3/1.mp3';
// import sound2 from '../assets/mp3/2.mp3';
// import sound3 from '../assets/mp3/3.mp3';
// import sound4 from '../assets/mp3/4.mp3';
// import sound5 from '../assets/mp3/5.mp3';
// import sound6 from '../assets/mp3/6.mp3';
// import sound7 from '../assets/mp3/7.mp3';
// import sound8 from '../assets/mp3/8.mp3';
// import sound9 from '../assets/mp3/9.mp3';

import { importAll } from '../../utils'

const soundsModules = importAll(
    require.context('../../assets/mp3/room-tones', false, /\.(mp3)$/)
);

export const sounds = soundsModules.map( module => module.default);


console.log(sounds);

// import sound0 from '../assets/mp3/slowstat2018G196hihi-edit1.mp3';
// import sound1 from '../assets/mp3/nmstut-dbgb-3L-30.mp3';
// import sound2 from '../assets/mp3/breath_shards_edit1.mp3';
// import sound3 from '../assets/mp3/ntt2016swell-wide1-c262-edit1.mp3';
// import sound4 from '../assets/mp3/breath_shards_long_low_full.mp3';
// import sound5 from '../assets/mp3/solswell2017-DAmlow-edit1.mp3';
// import sound6 from '../assets/mp3/nmstut-bcd-3L-17-edit1.mp3';
// import sound7 from '../assets/mp3/n2nb-singles-gadlo-edit1.mp3';
// import sound8 from '../assets/mp3/digistat-DGABGD-lo1.mp3';
// import sound9 from '../assets/mp3/2017-nndt-dgvlo-edit1.mp3';

// export const sounds = [sound0, sound1, sound2, sound3, sound4, sound5, sound6, sound7, sound8, sound9];